module.exports = __webpack_public_path__ + "img/mobile-side-icon-before.22af6b85.svg";